import {useEffect, useState} from 'react'
import {Button, Alert} from 'react-bootstrap'
import {useSelector, useDispatch} from 'react-redux'
import { useLocation } from 'react-router'
import {Link} from 'react-router-dom'
import { WithContext as ReactTags } from 'react-tag-input'
import {userActivate, userPromote, userRemove, userLinkMember, userUnlinkMember, userTogglePublicAccount} from '../actions/userActions'
import {getMembersBySearch} from '../actions/memberActions'
import {USER_LINK_MEMBER_UNSET, USER_REMOVE_UNSET} from '../constants/userConstant'
import Loader from '../components/Loader'
import Popup from '../components/PopupMessage'
import Modal from '../components/Modal'

const KeyCodes = {
    enter: 13
}

const delimiters = [KeyCodes.enter]

const UserInfo = ({info, ind}) => {
    const {user:{data}} = useSelector(state => state.login)
    const {loading, error} = useSelector(state => state.activate)
    const {loading:loading_p, error:error_p} = useSelector(state => state.promote)
    const {loading:loading_public, error:error_public} = useSelector(state => state.publicAccount)
    const {success, error:error_r} = useSelector(state => state.remove)
    const {loading:loading_l, error:error_l, success:success_l, message:message_l} = useSelector(state => state.linkMember)
    const {loading:loading_s, error:error_s, members} = useSelector(state => state.memberSearch)
    const [isLinkModalOpen, setIsLinkModalOpen] = useState(false)
    const [memberTags, setMemberTags] = useState([])
    const [memberSuggestions, setMemberSuggestions] = useState([])
    const dispatch = useDispatch()
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    if(query.get('page')) { 
        ind += (query.get('page') - 1)* 10
    }
    const userActiveHandler = _ => {
        dispatch(userActivate(info._id))
    }

    const userCoAdminHandler = _ => {
       dispatch(userPromote(info._id))
    }
    const publicAccountHandler = _ => {
       dispatch(userTogglePublicAccount(info._id))
    }
    const removeUserHandler = _ => {
        const isConfirm = window.confirm('هل أنت متاكد من حذف المستخدم')
        if(isConfirm){
            dispatch(userRemove(info._id))
        }
    }
    const memberSearchHandler = value => {
        dispatch(getMembersBySearch(value))
    }
    const memberAdditionHandler = tag => {
        setMemberTags([tag])
    }
    const linkMemberHandler = _ => {
        if(memberTags[0] && memberTags[0]._id) {
            dispatch(userLinkMember(info._id, memberTags[0]._id))
            setIsLinkModalOpen(false)
            setMemberTags([])
        }
    }
    const unlinkMemberHandler = _ => {
        const isConfirm = window.confirm('هل أنت متاكد من إلغاء ربط المستخدم بعضو العائلة؟')
        if(isConfirm) dispatch(userUnlinkMember(info._id))
    }
    const linkedMember = info.memberId

    useEffect(() => {
        if(members) setMemberSuggestions(members)
        else if(loading_s) setMemberSuggestions([{id:'جارى البحث ...', name:'جارى البحث ...'}])
        else if(error_s) setMemberSuggestions([{id:error_s, name:error_s}])
    }, [members, loading_s, error_s])

    return (
        <>
        <Modal
            heading={`ربط ${info.firstName} ${info.lastName} بعضو من العائلة`}
            show={isLinkModalOpen}
            onHide={() => {
                setIsLinkModalOpen(false)
                setMemberTags([])
            }}
        >
            {loading_l && <Loader/>}
            {error_l && <Alert variant='danger'>{error_l}</Alert>}
            <ReactTags
                placeholder='ابحث باسم العضو'
                tags={memberTags}
                suggestions={memberSuggestions}
                labelField='name'
                handleDelete={() => setMemberTags([])}
                handleAddition={memberAdditionHandler}
                handleInputChange={memberSearchHandler}
                delimiters={delimiters}
                allowDeleteFromEmptyInput={false}
                allowDragDrop={false}
                inputProps={{disabled:memberTags.length > 0}}
            />
            <Button
                variant='primary'
                style={{marginTop:'1rem'}}
                disabled={!memberTags[0] || !memberTags[0]._id || loading_l}
                onClick={linkMemberHandler}
            >
                ربط العضو
            </Button>
        </Modal>
        {loading || loading_p || loading_public || loading_l
        ? <Loader/>
        : (error || error_p || error_public || error_l) && <Popup danger passHandler={() => dispatch({type:USER_LINK_MEMBER_UNSET})}><p>{error || error_p || error_public || error_l}</p></Popup>}
        {success ? <Popup success passHandler={() => dispatch({type:USER_REMOVE_UNSET})}><p>تم حذف المستخدم بنجاح</p></Popup>
        :error_r && <Popup danger passHandler={() => dispatch({type:USER_REMOVE_UNSET})}><p>{error_r}</p></Popup>}
        {success_l && <Popup success passHandler={() => dispatch({type:USER_LINK_MEMBER_UNSET})}><p>{message_l}</p></Popup>}
        {!info.isAdmin&&<tr>
            <td>{ind}</td>
            <td> <span>{`${info.firstName} ${info.lastName}`}</span></td>
            <td> <a href={`mailto:${info.email}`}>{info.email}</a></td>
            <td><a href={`tel:${info.phone}`}>{info.phone}</a></td>
            <td>
                {linkedMember
                ? <div style={{display:'flex', gap:'0.8rem', alignItems:'center', justifyContent:'center', flexWrap:'wrap'}}>
                    <Link to={`/info/${linkedMember._id || linkedMember}`}>{linkedMember.firstName || 'عضو مرتبط'}</Link>
                    {!info.isPublicAccount && <Button variant='light' onClick={() => setIsLinkModalOpen(true)}>تغيير</Button>}
                    {!info.isPublicAccount && <Button variant='secondary' onClick={unlinkMemberHandler}>فك</Button>}
                </div>
                : info.isPublicAccount ? <span>حساب عام للتصفح</span> : <Button variant='info' onClick={() => setIsLinkModalOpen(true)}>ربط بعضو</Button>}
            </td>
            {data.isAdmin && <td>
                {info.isPublicAccount
                ? <i title='الحساب العام لا يمكن ترقيته'
                style={{color:'#7b8a8b'}}
                className="fas fa-ban"></i>
                : info.isCoAdmin
                ? <i title='اضغط لإلغاء تعيين مساعد المدير'  
                style={{color:'#13967d', cursor:'pointer'}} 
                onClick={() => userCoAdminHandler('coAdmin')}
                className="fas fa-hands-helping"></i> 
                
                : <i title='اضغط لتعيين مساعد مدير' 
                style={{color:'#e74c3c', cursor:'pointer'}} 
                onClick={() => userCoAdminHandler('')} 
                className="fas fa-handshake-alt-slash"></i>
                }
            </td>}
            {data.isAdmin && <td>
                {info.isPublicAccount
                ? <i title='اضغط لإلغاء الحساب العام'
                style={{color:'#13967d', cursor:'pointer'}}
                onClick={publicAccountHandler}
                className="fas fa-eye"></i>
                : <i title='اضغط لتعيين حساب عام للتصفح فقط'
                style={{color:'#7b8a8b', cursor:'pointer'}}
                onClick={publicAccountHandler}
                className="fas fa-eye-slash"></i>}
            </td>}
            <td>
                {info.isActive 
                ? <i 
                title='اضغط لإلغاء تفعيل الحساب'  
                style={{color:'#13967d', cursor:'pointer'}} 
                onClick={() => userActiveHandler()}
                className="fas fa-user-check"></i> 
                : <i 
                title='اضغط لتفعيل الحساب' 
                style={{color:'#e74c3c', cursor:'pointer'}} 
                onClick={() => userActiveHandler()} 
                className="fas fa-user-lock"></i>}
            </td>
            <td>   
                <Button variant='danger' onClick={removeUserHandler}><i className="fas fa-trash"></i></Button>    
            </td>
        </tr>}</>
    )
}

export default UserInfo
